import React from 'react';
import { Eye, Navigation2, Users, Settings } from 'lucide-react';

export const LayerControls = ({
  showStreetView,
  onToggleStreetView,
  showDirections,
  onToggleDirections,
  showTeamMembers,
  onToggleTeamMembers,
  showStatusBar,
  onToggleStatusBar
}) => {
  const getButtonStyles = (active) => {
    if (active) return 'bg-blue-500 text-white hover:bg-blue-600';
    return 'bg-white text-gray-400 hover:text-gray-600';
  };

  return (
    <div className="space-y-2">
      <button
        onClick={onToggleStreetView}
        className={`p-2 rounded-full shadow-lg block ${getButtonStyles(showStreetView)}`}
        title="Street View"
      >
        <Eye className="w-4 h-4" />
      </button>
      <button
        onClick={onToggleDirections}
        className={`p-2 rounded-full shadow-lg block ${getButtonStyles(showDirections)}`}
        title="Toggle Directions"
      >
        <Navigation2 className="w-4 h-4" />
      </button>
      <button
        onClick={onToggleTeamMembers}
        className={`p-2 rounded-full shadow-lg ${getButtonStyles(showTeamMembers)}`}
        title="Team Members"
      >
        <Users className="w-4 h-4" />
      </button>
      <button
        onClick={onToggleStatusBar}
        className={`p-2 rounded-full shadow-lg ${getButtonStyles(showStatusBar)}`}
        title="Status Bar"
      >
        <Settings className="w-4 h-4" />
      </button>
    </div>
  );
};